import { ref, get, child } from "firebase/database";
import { YEAR } from "./config";

// Every user's confirmations for the season, flattened into one list
// with the owner's building/unit attached. Admin-only: reading all of
// /users requires the isAdmin claim.
export async function fetchConfirmations(db) {
  const snapshot = await get(child(ref(db), "users"));
  if (!snapshot.exists()) return [];
  const users = snapshot.val();
  const all = [];
  for (const uid in users) {
    const confirmations = users[uid]?.[`confirmations${YEAR}`];
    if (!confirmations) continue;
    for (const id in confirmations) {
      all.push({
        uid,
        id,
        ...confirmations[id],
        ownerBuilding: users[uid]?.building || "",
        ownerUnit: users[uid]?.unit || "",
      });
    }
  }
  return all;
}
